module.exports = __webpack_public_path__ + "static/media/ndi-leaflet.0e417837.png";